import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';

@Component({
  selector: 'notifications-component',
  template: `{{ data }}`,
})
export class NotificationsComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string) { }
}